import React from 'react';
import DashboardLayout from '../components/DashboardLayout';
import UnifiedDocuments from '../components/UnifiedDocuments';

const AdminDocumentCenterPage = () => (
  <DashboardLayout>
    <div data-testid="admin-document-center-page">
      <UnifiedDocuments isAdmin />
    </div>
  </DashboardLayout>
);

export default AdminDocumentCenterPage;
